import {Accordion, styled} from "@mui/material";
import "./stepsAccordian.scss";

const StepsAccordion = styled(Accordion)(({ theme }) => {
    return {
        boxShadow: 'none',
        border: `none`,
        '.MuiAccordionDetails-root': {
            padding: 0,
            margin: "0 24px 24px 24px"
        },
        '.MuiAccordionSummary-root': {},
        '.MuiPaper-root.MuiAccordion-root::before': {
            backgroundColor: 'none'
        },
        '.MuiAccordion-root .Mui-expanded': {
            minHeight: '48px'
        }
    };
});

export default StepsAccordion;